import React from 'react'
import _ from 'lodash'

export var convertImgSrc = src => {
  if (src.includes("http")) {
    return src
  } else {
    return "https://static.stgairasia.com/seo/static-assets/SEOFlightsImages" + src
  }
}

export var convertLink = (url)=>url.replace("https://www.airasia.com/flights/","")
export var GlobalContext = React.createContext({});

export const useDfpSlot = (width, lang, origin, dest) => {
  console.log("from useDfpSlot -- started", { lang, width, origin, dest, gt: window.googletag, winType: typeof(window) })
  if (typeof window === 'undefined' || !(window.googletag)) return;
  const googletag = window.googletag || {};

  googletag.cmd = googletag.cmd || [];
  //   if(JSON.stringify(SetArr)!= JSON.stringify(width))
  //   {
  //       console.log("Arr",SetArr,"arr",widthArr)
  if (googletag.destroySlots)
    googletag.destroySlots();
  //   }
  googletag.cmd.push(function () {
    // var width = window.innerWidth 
    // console.log("gpt width",width)
    console.log("from useDfpSlot -- ", { lang, width, origin, dest })
    googletag.pubads().setTargeting('lg', [lang]).setTargeting('o', origin ? [origin] : []).setTargeting('d', dest ? [dest] : []);

    googletag.defineSlot('/10025506/AirAsia.com/seo_page/prime', width, 'div-gpt-ad-1586342250790-0').addService(googletag.pubads());
    googletag.defineSlot('/10025506/AirAsia.com/seo_page/footer', width, 'div-gpt-ad-1586342250790-1').addService(googletag.pubads());
    googletag.pubads().setCentering(true);
    // googletag.pubads().enableLazyLoad({
    //   // Fetch slots within 2 viewports.
    //   fetchMarginPercent: 200,
    //   // Render slots within 1 viewports.
    //   renderMarginPercent: 100,
    //   // Double the above values on mobile, where viewports are smaller
    //   // and users tend to scroll faster.
    //   mobileScaling: 2.0
    // });
    googletag.pubads().enableSingleRequest();
    googletag.enableServices();
  });

  googletag.cmd.push(function () { googletag.display('div-gpt-ad-1586342250790-0'); });
  googletag.cmd.push(function () { googletag.display('div-gpt-ad-1586342250790-1'); });
};
export const DynamicWidth=(SetWidth)=>{
    // console.log("running dynamic width",window.innerWidth );
    
    if (typeof window === 'undefined') return;
  
    const handleResize = () => {
        var width = window.innerWidth 
        // console.log("Got witdh", width);
        var SetArr = []
        
        if (width >= 990) {
            SetArr = [970, 90]
        }
        else if ((width >= 748) && (width < 990)) {
            SetArr = [728, 90]
        }
        else if ((width >= 570) && (width < 748)) {
            SetArr = [570, 180]
        }
        else {
            SetArr = [300, 250]
        }
        SetWidth(PreArr=>
            {
            // console.log("Arr",PreArr,SetArr,JSON.stringify(PreArr)!= JSON.stringify(SetArr))
                if(JSON.stringify(PreArr)!= JSON.stringify(SetArr)){
                        return SetArr
        }
    return PreArr
    })
       
    }
    handleResize()
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize)
    };
  }

export const fireGtmEvent = obj => {
  try{
    if (typeof window !== "undefined") {
      window.gtmDataLayer = window.gtmDataLayer || []
      window.gtmDataLayer.push(obj)
    }
  }catch(err){
    console.error("Error in firing GTM event", err);
  }
  }

export const getDateProperizedContent = (obj, lang) => {
  if (_.isPlainObject(obj)) {
    let strJson = JSON.stringify(obj);
    let correctedJsonStr = strJson.replaceAll('{{current_year}}', new Date().toLocaleDateString(lang).split('/')[2]);
    return JSON.parse(correctedJsonStr);
    // let keys = _.keys(obj);
    // return keys.reduce((acc, x) => {
    //   let target = _.get(obj, x);
    //   if (_.isString(target)) {
    //     acc[x] = target.replaceAll('{{current_year}}', new Date().toLocaleDateString(lang).split('/')[2]);
    //   } else {
    //     acc[x] = obj[x];
    //   }
    //   return acc;
    // }, {})
  }
  return obj
};